import colors from '../../theme/foundations/colors'
import {fonts} from '../../theme/foundations/fonts'
import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'
import size from '../../utills/size'

export const productPageStyle = {
    padding: `${pxToRem(10)} ${pxToRem(45)} ${pxToRem(0)} ${pxToRem(45)}`,
    maxWidth: size.xxl,
    margin: '0 auto',
    [`@media (max-width: ${sizes.container.md})`]: {
        padding: `${pxToRem(11)} ${pxToRem(11)}`
    }
}

export const titleStyle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(22),
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase',
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(18),
        marginTop: pxToRem(-10)
    }
}

export const priceStyle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    color: 'black'
}

export const salePriceStyle = {
    color: 'cav_red'
}

export const savingPriceStyle = {
    marginTop: pxToRem(6),
    marginBottom: '0',
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    color: 'cav_red'
}

export const addToCartButton = {
    width: pxToRem(295),
    height: pxToRem(40),
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0',
    alignItems: 'center',
    flexShrink: '0',
    backgroundColor: 'cav_red',
    textTransform: 'uppercase',
    fontFamily: fonts.primary,
    fontSize: pxToRem(14),
    fontWeight: '700',
    letterSpacing: pxToRem(1.68),
    lineHeight: pxToRem(13.5),
    [`@media (max-width: ${sizes.container.md})`]: {
        height: pxToRem(35),
        padding: `${pxToRem(10)} ${pxToRem(86)}`,
        fontSize: pxToRem(12),
        letterSpacing: pxToRem(1.44)
    },
    [`@media (max-width: ${sizes.container.sm})`]: {
        flex: '1'
    },
    '&:hover': {
        backgroundColor: 'white',
        color: 'cav_red',
        border: `${pxToRem(1)} solid ${colors.cav_red}`
    },
    ':disabled': {
        backgroundColor: 'cav_red',
        '&:hover': {
            backgroundColor: 'cav_red',
            color: 'white !important'
        }
    }
}

export const wishlistButton = {
    width: pxToRem(40),
    minWidth: pxToRem(40),
    height: pxToRem(40),
    flexShrink: '0',
    border: `${pxToRem(1)} solid ${colors.black}`,
    borderRadius: '0',
    background: 'rgba(174, 18, 42, 0.0)',
    padding: '0',
    [`@media (max-width: ${sizes.container.md})`]: {
        width: pxToRem(35),
        minWidth: pxToRem(35),
        maxWidth: pxToRem(35),
        height: pxToRem(35)
    },
    '&:hover': {
        background: 'white'
    }
}

export const wishlistIcon = {
    width: pxToRem(22),
    aspectRatio: 'auto 84 / 73',
    flexShrink: '0',
    [`@media (max-width: ${sizes.container.md})`]: {
        width: pxToRem(20),
        flexShrink: '0'
    }
}

export const wishlistTooltip = {
    background: 'blackAlpha.650',
    color: 'white',
    borderRadius: '0',
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: '400',
    letterSpacing: pxToRem(1)
}

export const renderButtons = {
    display: 'flex',
    gap: pxToRem(15),
    [`@media (max-width: ${sizes.container.sm})`]: {
        gap: pxToRem(5),
        width: '100%',
        justifyContent: 'space-between'
    }
}

export const inventoryMessageStyle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    letterSpacing: pxToRem(1.28),
    textTransform: 'uppercase',
    color: 'cav_red',
    marginBottom: '0',
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14),
        letterSpacing: pxToRem(1.12)
    }
}

export const viewLinkStyle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    letterSpacing: pxToRem(1.28),
    textTransform: 'uppercase',
    color: 'cav_red',
    textDecoration: 'none',
    marginBottom: '0',
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14),
        letterSpacing: pxToRem(1.12)
    }
}

export const productSuggestionStyle = {
    as: 'span',
    fontFamily: fonts.primary,
    fontSize: pxToRem(22),
    fontWeight: '600',
    color: 'black',
    m: 0,
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(18)
    }
}

export const hideAfterEighthImgs = {
    '.assetWrapper:nth-of-type(n+9)': {
        display: 'none'
    }
}
